// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { DateTime } from 'luxon';
import type { PartialDeep } from 'type-fest';

import * as DateHelpers from '../../../utils/dateHelpers';
import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import Enums from '../Enums';
import {
  type LinkedDispatchCustomerDispatch,
  type LinkedDispatchCustomerDispatchWireFormat,
  NewLinkedDispatchCustomerDispatch,
} from '../LinkedDispatchCustomerDispatch/LinkedDispatchCustomerDispatch';

export class LinkedDispatchCustomer {
  readonly id: string;
  readonly companyId: string;
  readonly companyName: string;
  readonly address: string | null;
  readonly actionBy: string | null;
  readonly actionDate: DateTime;
  readonly linkDate: string | null;
  readonly mergeDate: string | null;
  readonly dispatchCustomers: LinkedDispatchCustomerDispatch[];
  readonly integrationIds: string[];
  readonly integrationTypes: Enums.IntegrationType[];
  readonly isMergedAction: boolean;
  readonly isLinkedAction: boolean;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.companyId = data.companyId === undefined ? NIL_UUID : data.companyId;
    this.companyName = data.companyName === undefined ? '' : data.companyName;
    this.address = data.address === undefined ? null : data.address;
    this.actionBy = data.actionBy === undefined ? null : data.actionBy;
    this.actionDate = DateHelpers.ParseServerDateTime(data.actionDate);
    this.linkDate = data.linkDate === undefined ? null : data.linkDate;
    this.mergeDate = data.mergeDate === undefined ? null : data.mergeDate;
    this.dispatchCustomers = (data.dispatchCustomers ?? []).map((dispatchCustomers: any) =>
      NewLinkedDispatchCustomerDispatch(dispatchCustomers),
    );
    this.integrationIds = (data.integrationIds ?? []).map((integrationIds: any) =>
      integrationIds === undefined ? NIL_UUID : integrationIds,
    );
    this.integrationTypes = (data.integrationTypes ?? []).map((integrationTypes: any) =>
      integrationTypes === undefined ? Enums.IntegrationType.Series : integrationTypes,
    );
    this.isMergedAction = data.isMergedAction === undefined ? false : data.isMergedAction;
    this.isLinkedAction = data.isLinkedAction === undefined ? false : data.isLinkedAction;
  }

  static zero(): LinkedDispatchCustomer {
    const zeroValues: ExcludeMethodsDeep<LinkedDispatchCustomer> = {
      id: NIL_UUID,
      companyId: NIL_UUID,
      companyName: '',
      address: null,
      actionBy: null,
      actionDate: DateHelpers.ParseServerDateTime(DateHelpers.ZERO_DATE_STRING),
      linkDate: null,
      mergeDate: null,
      dispatchCustomers: [],
      integrationIds: [],
      integrationTypes: [],
      isMergedAction: false,
      isLinkedAction: false,
    };
    return new LinkedDispatchCustomer(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type LinkedDispatchCustomerWireFormat = {
  id: string;
  companyId: string;
  companyName: string;
  address: string | null;
  actionBy: string | null;
  actionDate: string;
  linkDate: string | null;
  mergeDate: string | null;
  dispatchCustomers: LinkedDispatchCustomerDispatchWireFormat[];
  integrationIds: string[];
  integrationTypes: string[];
  isMergedAction: boolean;
  isLinkedAction: boolean;
};

type NewLinkedDispatchCustomerProps = PartialDeep<
  LinkedDispatchCustomer,
  { recurseIntoArrays: true }
>;
export const NewLinkedDispatchCustomer: (
  props: NewLinkedDispatchCustomerProps,
) => LinkedDispatchCustomer = (props) => new LinkedDispatchCustomer(props);

type NewLinkedDispatchCustomerFromWireFormatProps = PartialDeep<
  LinkedDispatchCustomerWireFormat,
  { recurseIntoArrays: true }
>;
export const NewLinkedDispatchCustomerFromWireFormat: (
  props: NewLinkedDispatchCustomerFromWireFormatProps,
) => LinkedDispatchCustomer = (props) => new LinkedDispatchCustomer(props);
